<template>
  <div>
    <div class="productBar">
      <div class="auto clearfix">
        <h2 class="fl">
          产品：大智慧策略投资终端
          <span>非投资咨询类软件产品</span>
        </h2>
        <div class="p-nav fr">
          <span :class="{'cur' :navIndex === index}" @click="selectNav(index)" v-for="(item, index) in nav" :key="index">{{ item }}</span>
        </div>
      </div>
    </div>
    <div class="gnysCon" v-show="navIndex === 0">
      <div class="header">
        <h1>
          <span>
            <em>3.8万/年</em>5.8万/2年
          </span>
        </h1>
        <img src="../../assets/images/product/113/banner01.jpg" width="100%" />
        <img src="../../assets/images/product/113/banner02.jpg" width="100%" />
      </div>
      <div class="w w-top">
        <h2>资金模型</h2>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《ACE》最新资金计算模型，捕捉主力埋伏个股。</h3>
          <img src="../../assets/images/product/113/img_03.jpg" alt />
        </div>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《资金先锋》日内资金排头兵。</h3>
          <img src="../../assets/images/product/113/img_06.jpg" alt />
        </div>
      </div>
      <div class="w">
        <h2>市场热点</h2>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《热点轮动》解析市场轮动热点轨迹，智能区分板块龙头股。</h3>
          <img src="../../assets/images/product/113/img_08.jpg" alt />
        </div>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《主题投资》题材更细，挖掘热门题材中的分支。</h3>
          <img src="../../assets/images/product/113/img_10.jpg" alt />
        </div>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>大数据掘金</h3>
          <img src="../../assets/images/product/113/img_13.jpg" alt class="img_w2" />
          <img src="../../assets/images/product/113/img_16.jpg" alt class="img_w2" />
        </div>
      </div>
      <div class="w">
        <h2>波段决策</h2>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《TS时间序列》波段操作，短线为王。</h3>
          <img src="../../assets/images/product/113/img_19.jpg" alt />
        </div>
      </div>
      <div class="w">
        <h2>资讯天眼</h2>
      </div>
      <div class="main-item bgs-item">
        <div class="w">
          <h3>《董秘爆料》一线新闻互动抢先知道。</h3>
          <img src="../../assets/images/product/113/img_22.jpg" alt />
        </div>
      </div>
      <div class="main-item bgs-item">
        <div class="w">
          <h3>《大投资人被套》从大股东被套的个股，找到价值投资机会。</h3>
          <img src="../../assets/images/product/113/img_24.jpg" alt />
        </div>
      </div>
    </div>
    <div class="xxgnCon" v-show="navIndex === 1">
      <product-detail113/>
    </div>
    <div class="gnysCon" v-show="navIndex === 2">
      <div class="header">
        <h1>
          <span>9800元/季度</span>
        </h1>
        <img src="../../assets/images/product/113/banner01.jpg" width="100%" />
        <img src="../../assets/images/product/113/banner02.jpg" width="100%" />
      </div>
      <div class="w w-top">
        <h2>资金模型</h2>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《ACE》最新资金计算模型，捕捉主力埋伏个股。</h3>
          <img src="../../assets/images/product/113/img_03.jpg" alt />
        </div>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《资金先锋》日内资金排头兵。</h3>
          <img src="../../assets/images/product/113/img_06.jpg" alt />
        </div>
      </div>
      <div class="w">
        <h2>市场热点</h2>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《热点轮动》解析市场轮动热点轨迹，智能区分板块龙头股。</h3>
          <img src="../../assets/images/product/113/img_08.jpg" alt />
        </div>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《主题投资》题材更细，挖掘热门题材中的分支。</h3>
          <img src="../../assets/images/product/113/img_10.jpg" alt />
        </div>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>大数据掘金</h3>
          <img src="../../assets/images/product/113/img_13.jpg" alt class="img_w2" />
          <img src="../../assets/images/product/113/img_16.jpg" alt class="img_w2" />
        </div>
      </div>
      <div class="w">
        <h2>波段决策</h2>
      </div>
      <div class="main-item">
        <div class="w">
          <h3>《TS时间序列》波段操作，短线为王。</h3>
          <img src="../../assets/images/product/113/img_19.jpg" alt />
        </div>
      </div>
      <div class="w">
        <h2>资讯天眼</h2>
      </div>
      <div class="main-item bgs-item">
        <div class="w">
          <h3>《董秘爆料》一线新闻互动抢先知道。</h3>
          <img src="../../assets/images/product/113/img_22.jpg" alt />
        </div>
      </div>
      <div class="main-item bgs-item">
        <div class="w">
          <h3>《大投资人被套》从大股东被套的个股，找到价值投资机会。</h3>
          <img src="../../assets/images/product/113/img_24.jpg" alt />
        </div>
      </div>
    </div>
    <float-bar :id="id" :month="month"/>
  </div>
</template>

<script>
import ProductDetail113 from "@/components/product/ProductDetail113.vue";
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  data() {
    return {
      id: this.$parent.id,
      month : 12,
      nav: ["功能演示", "详细功能", "季卡购买"],
      navIndex: 0
    };
  },
  created () {
    document.title = "大智慧策略投资终端";
  },
  methods:{
    selectNav(index){
      this.navIndex = index;
      if (index == 2) {
        this.month = 3;
      }
    }
  },
  components: {
    ProductDetail113,
    FloatBar
  }
};
</script>

<style lang="scss" scoped>
.gnysCon {
  background: #000;
  .header {
    position: relative;
    h1 {
      @include wh(100%, 50px);
      text-align: center;
      position: absolute;
      top: 49.5%;
      left: 0;
      span {
        @include fc(36px, #e3b869);
        @include line-height(50px);
        padding: 0 40px;
        border-radius: 20px;
        background: #7e1a00;
        display: inline-block;
        em {
          margin-right: 40px;
        }
      }
    }
  }

  .w {
    width: 1000px;
    margin: 0 auto;
    h2 {
      width: 300px;
      margin: 0 auto 58px;
      line-height: 50px;
      font-size: 36px;
      text-align: center;
      font-weight: bold;
      background: url("~@/assets/images/product/113/bg_slogn.jpg") no-repeat
        center top;
      color: #0d0d0d;
    }
  }
  .w-top {
    padding-top: 60px;
    border-top: 4px solid #e4d095;
  }
  .main-item {
    padding-bottom: 50px;
    background: url("~@/assets/images/product/113/bg_star.jpg") repeat-y center
      top;
    h3 {
      background: url("~@/assets/images/product/113/bg_title.jpg") no-repeat
        center top;
      font-size: 30px;
      color: #f5e7bf;
      line-height: 60px;
      height: 60px;
      text-align: center;
    }
    img {
      width: 690px;
      margin: 35px auto 0;
      display: block;
      &.img_w2 {
        width: 780px;
      }
    }
  }
  .bgs-item {
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
  }
}
.p-nav span {
  &:nth-child(2) {
    margin-right: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product113.vue